import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../../elements/Humberg.jsx'
import { useSearchParams } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../loader/loader.jsx'
import { OrderDetailsAction } from '../../../redux/actions/orderActions.js'
import { formatDbDate, formatDbDateWithoutTime } from '../../../utils/dateFormater.js'
import { formatWhatsAppNumber } from '../../../utils/whatsappLinkFormater.js'
import HoverFullText from '../../../elements/HoverToolKit.jsx'
import SingleOrderButtons from './SingleOrderButtons.jsx'
import { clearErrors } from '../../../redux/actions/userActions.js'
import { CREATE_ORDER_RESET } from '../../../redux/constants/orderConstants.js'
const SingleOrder = () => {




    const dispatch = useDispatch()


    const { loading, order, orderLogs, orderRemarks } = useSelector(state => state.orders)
    const { loading: createOrderLoading, error, message } = useSelector(state => state.order)

    const { user } = useSelector(state => state.verifyEmailStore)



    const [searchParams] = useSearchParams();
    const id = searchParams.get("order_id");


    const [showPopup, setshowPopup] = useState(false)
    const [imgUrlToShow, setImgUrlToShow] = useState("")



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("orders")


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `Order Details`;

    }, [order]);



    useEffect(() => {


        if (id) {

            dispatch(OrderDetailsAction(id))
        }


    }, [id, dispatch])




    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }
    const handleBackground = (orderStatus) => {



        if (orderStatus === "ORDERED") return "bg-green-600 ";
        if (orderStatus === "REVIEWED") return "bg-pink-500 ";
        if (orderStatus === "DELIVERED") return "bg-orange-500 ";
        if (orderStatus === "SUSPENDED") return "bg-orange-500 ";
        if (orderStatus === "ON_HOLD") return "bg-blue-500 ";
        if (orderStatus === "REFUNDED") return "bg-green-600 ";
        if (orderStatus === "COMMISSIONED") return "bg-slate-500";
        if (orderStatus === "COMPLETED") return "bg-purple-500 ";
        if (orderStatus === "CANCELLED") return "bg-[#B04926] ";
        if (orderStatus === "REVIEW_DELETED") return "bg-red-500";
        if (orderStatus === "SYSTEM_CANCELLED") return "bg-red-500";

    }





    useEffect(() => {


        if (error) {
            dispatch(clearErrors())
        }
        if (message) {
            dispatch({ type: CREATE_ORDER_RESET })
            dispatch(OrderDetailsAction(id))
        }

    }, [error, message, dispatch, id])








    return (
        <Fragment>
            {(loading || createOrderLoading) && <Loader />}
            <Humberg header="Orders" headerLink="/" children={"All Orders"}
                innerChildren={"Order : " + order?.id} />

            <section className='p-[1.5vmax] pt-[1vmax] mb-[8vmax]' >
                <div className='grid grid-cols-1 lg:grid-cols-[2.5fr,1.5fr] gap-[2vmax]'>

                    {/* Left Column */}
                    <div className="flex flex-col gap-[2vmax]">

                        {/* Order Details Card */}
                        <div className='bg-white rounded-xl p-[2vmax] shadow-sm border border-gray-100'>
                            <div className="flex justify-between items-center w-full mb-[1.5vmax] border-b border-gray-100 pb-[1vmax]">
                                <div className="flex items-center gap-[0.5vmax]">
                                    <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                                    <h2 className='text-[1.3vmax] font-bold text-gray-800'>Order Details</h2>
                                </div>
                                <span className={`text-[0.9vmax] font-bold uppercase p-[0.3vmax_0.8vmax] rounded-lg shadow-sm ${handleClassName(order?.status)}`} >
                                    {order?.status === "ON_HOLD" ? "ON HOLD" : order?.status === "REVIEW_DELETED" ? "REVIEW DELETED" : order?.status === "SYSTEM_CANCELLED" ? "SYSTEM CANCEL" : order?.status}
                                </span>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.5vmax]">
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Order ID</span>
                                    <span className='text-[1.1vmax] font-bold text-gray-700 mt-1'>#{order?.id}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Customer Email</span>
                                    <span className='text-[1.1vmax] font-bold text-gray-700 mt-1 truncate' title={order?.paypal_email}>{order?.paypal_email}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Order Number</span>
                                    <span className='text-[1.1vmax] font-bold text-gray-700 mt-1'>{order?.order_number}</span>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-[1.5vmax] mt-[2vmax]">
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Est Price</span>
                                    <span className='text-[1.1vmax] font-bold text-gray-700 mt-1'>$ {order?.product_price}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>{user?.role === "PM" ? "" : "PM"} Commission</span>
                                    <span className='text-[1.1vmax] font-bold text-emerald-600 mt-1'>{order?.pm_commission_amount ? `Rs. ${order.pm_commission_amount}` : "N/A"}</span>
                                </div>
                                {(user?.role === "SUPER_ADMIN" || user?.role === "PMM") &&
                                    <div className="flex flex-col">
                                        <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Portal Commission</span>
                                        <span className='text-[1.1vmax] font-bold text-indigo-600 mt-1'>{order?.portal_commission_amount ? `Rs. ${order.portal_commission_amount}` : "N/A"}</span>
                                    </div>
                                }
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Created At</span>
                                    <span className='text-[1.1vmax] font-bold text-gray-700 mt-1'>{formatDbDateWithoutTime(order?.created_at)}</span>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 mt-[2vmax]">
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Amazon Review Link</span>
                                    <span className='text-[1.1vmax] font-bold mt-1'>
                                        {order?.amazon_review_link !== "null" ? (
                                            <a href={order?.amazon_review_link} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 flex items-center gap-1 transition-colors">
                                                <HoverFullText text={order?.amazon_review_link} sliceLength={70} />
                                                <i className="fa-solid fa-arrow-up-right-from-square text-xs"></i>
                                            </a>
                                        ) : "N/A"}
                                    </span>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 mt-[2vmax]">
                                <div className="flex flex-col">
                                    <span className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Review Remarks</span>
                                    <div className='text-[1vmax] font-medium text-gray-700 mt-1 bg-gray-50 p-[1vmax] rounded-lg border border-gray-100'>
                                        {order?.remarks === "null" ? "N/A" : <div dangerouslySetInnerHTML={{ __html: order?.remarks }} />}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Order Activity Card */}
                        <div className="bg-white p-[2vmax] shadow-sm rounded-xl border border-gray-100">
                            <div className="flex items-center gap-[0.5vmax] mb-[1.5vmax]">
                                <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                                <h2 className='text-[1.3vmax] font-bold text-gray-800'>Order Activity</h2>
                            </div>

                            <div className="flex flex-col gap-[1vmax]">
                                {/* Initial State */}
                                <div className="flex gap-[1vmax]">
                                    <div className="flex flex-col items-center">
                                        <div className="w-[1.2vmax] h-[1.2vmax] bg-green-500 rounded-full border-[0.2vmax] border-white shadow-sm"></div>
                                        <div className="w-[0.15vmax] h-full bg-gray-200"></div>
                                    </div>
                                    <div className="pb-[1.5vmax]">
                                        <p className="text-[1vmax] font-medium text-gray-700">
                                            Order status Mark as <span className={`font-bold ${handleClassName("ORDERED")} px-2 py-0.5 rounded`}>ORDERED</span> by <strong className='text-gray-900'>{order?.pm_name}</strong>
                                        </p>
                                        <span className='text-[0.8vmax] text-gray-400 font-medium'>{formatDbDate(order?.created_at)}</span>
                                    </div>
                                </div>

                                {/* Logs */}
                                {orderLogs?.length > 0 &&
                                    orderLogs?.map((log, index) => (
                                        <div className="flex gap-[1vmax]" key={log?.id}>
                                            <div className="flex flex-col items-center">
                                                <div className={`w-[1.2vmax] h-[1.2vmax] ${handleBackground(log?.new_status)} rounded-full border-[0.2vmax] border-white shadow-sm`}></div>
                                                {index !== orderLogs.length - 1 && <div className="w-[0.15vmax] h-full bg-gray-200"></div>}
                                            </div>
                                            <div className="pb-[1.5vmax]">
                                                <p className="text-[1vmax] font-medium text-gray-700">
                                                    Order status changed from <span className={`font-bold ${handleClassName(log?.previous_status)} px-2 py-0.5 rounded`}>{log?.previous_status}</span>
                                                    <i className="fa-solid fa-arrow-right mx-2 text-gray-400 text-xs"></i>
                                                    <span className={`font-bold ${handleClassName(log?.new_status)} px-2 py-0.5 rounded`}>{log?.new_status}</span>
                                                    &nbsp;by <strong className='text-gray-900'>{log?.user_name}</strong>
                                                    <span className='text-gray-500 text-xs'> ({user?.id === log?.user_id ? "You" : log?.user_role})</span>
                                                </p>
                                                <span className='text-[0.8vmax] text-gray-400 font-medium'>{formatDbDate(log?.created_at)}</span>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        {/* Order Remarks Card */}
                        <div className="bg-white p-[2vmax] shadow-sm rounded-xl border border-gray-100">
                            <div className="flex items-center gap-[0.5vmax] mb-[1.5vmax]">
                                <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                                <h2 className='text-[1.3vmax] font-bold text-gray-800'>Order Remarks</h2>
                            </div>

                            {orderRemarks?.length > 0 ? (
                                <div className="flex flex-col gap-[1vmax]">
                                    {orderRemarks?.map((remarks) => (
                                        <div className="flex gap-[1vmax]" key={remarks?.id}>
                                            <div className="flex flex-col items-center">
                                                <div className="w-[1vmax] h-[1vmax] bg-blue-500 rounded-full border-[0.2vmax] border-white shadow-sm mt-1"></div>
                                                <div className="w-[0.15vmax] h-full bg-gray-200"></div>
                                            </div>
                                            <div className="pb-[1vmax]">
                                                <div className="bg-gray-50 p-[1vmax] rounded-lg border border-gray-100 text-[1vmax] text-gray-700 font-medium">
                                                    {remarks?.remarks}
                                                </div>
                                                <div className="mt-1 flex items-center gap-2">
                                                    <strong className='text-gray-700 text-[0.9vmax]'>{remarks?.user_name}</strong>
                                                    <span className='text-gray-400 text-xs'>({user?.id === remarks?.user_id ? "You" : remarks?.user_role})</span>
                                                    <span className='text-gray-400 text-xs'>• {formatDbDate(remarks?.created_at)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-[2vmax] text-gray-400 font-medium text-[1.1vmax]">
                                    No Record Found
                                </div>
                            )}
                        </div>

                        {/* On Hold Card (Conditional) */}
                        {order?.status === "ON_HOLD" &&
                            <div className='bg-white rounded-xl p-[2vmax] shadow-sm border border-gray-100'>
                                <div className="flex items-center gap-[0.5vmax] mb-[1vmax]">
                                    <div className="w-[0.3vmax] h-[1.5vmax] bg-amber-500 rounded-full"></div>
                                    <h2 className='text-[1.3vmax] font-bold text-gray-800'>On Hold Reason</h2>
                                </div>
                                <div className="bg-amber-50 p-[1vmax] rounded-lg border border-amber-100 text-[1vmax] font-medium text-gray-700">
                                    {order?.hold_reason || "No reason provided"}
                                </div>
                            </div>
                        }

                        {/* Order Evidence Card */}
                        <div className='bg-white rounded-xl p-[2vmax] shadow-sm border border-gray-100'>
                            <div className="flex items-center gap-[0.5vmax] mb-[1.5vmax]">
                                <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                                <h2 className='text-[1.3vmax] font-bold text-gray-800'>Order Evidence</h2>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[1.5vmax]">
                                {order?.order_proof_url &&
                                    <div className='border border-gray-200 p-[1vmax] rounded-xl hover:border-indigo-300 transition-colors cursor-pointer group shadow-sm'
                                        onClick={() => {
                                            setshowPopup(true)
                                            setImgUrlToShow(order?.order_proof_url)
                                        }}
                                    >
                                        <div className="w-full aspect-square bg-gray-50 overflow-hidden rounded-lg mb-[0.8vmax]">
                                            <img src={order?.order_proof_url} alt="Ordered Proof" className='w-full h-full object-cover group-hover:scale-105 transition-transform duration-300' />
                                        </div>
                                        <span className='text-[0.95vmax] font-bold text-gray-700 block text-center'>Ordered Proof</span>
                                        <span className='text-[0.8vmax] text-gray-400 font-medium block text-center mt-0.5'>{formatDbDate(order?.created_at)}</span>
                                    </div>
                                }

                                {order?.review_image_proof_url &&
                                    <div className='border border-gray-200 p-[1vmax] rounded-xl hover:border-indigo-300 transition-colors cursor-pointer group shadow-sm'
                                        onClick={() => {
                                            setshowPopup(true)
                                            setImgUrlToShow(order?.review_image_proof_url)
                                        }}
                                    >
                                        <div className="w-full aspect-square bg-gray-50 overflow-hidden rounded-lg mb-[0.8vmax]">
                                            <img src={order?.review_image_proof_url} alt="Reviewed Proof" className='w-full h-full object-cover group-hover:scale-105 transition-transform duration-300' />
                                        </div>
                                        <span className='text-[0.95vmax] font-bold text-gray-700 block text-center'>Reviewed Proof</span>
                                        <span className='text-[0.8vmax] text-gray-400 font-medium block text-center mt-0.5'>
                                            {formatDbDate(orderLogs?.filter(log => log.new_status === "REVIEWED")?.slice(-1)[0]?.created_at || "")}
                                        </span>
                                    </div>
                                }

                                {order?.refund_image_proof_url &&
                                    <div className='border border-gray-200 p-[1vmax] rounded-xl hover:border-indigo-300 transition-colors cursor-pointer group relative shadow-sm'
                                        onClick={() => {
                                            setshowPopup(true)
                                            setImgUrlToShow(order?.refund_image_proof_url)
                                        }}
                                    >
                                        <div className="w-full aspect-square bg-gray-50 overflow-hidden rounded-lg mb-[0.8vmax]">
                                            <img src={order?.refund_image_proof_url} alt="Refund Proof" className='w-full h-full object-cover group-hover:scale-105 transition-transform duration-300' />
                                        </div>
                                        <span className='text-[0.95vmax] font-bold text-gray-700 block text-center'>Refund Proof</span>
                                        <span className={`text-[0.75vmax] font-bold block text-center absolute top-[1.5vmax] right-[1.5vmax] p-[0.3vmax_0.6vmax] rounded-lg shadow-sm text-white ${order?.refund_confirmed === 0 ? 'bg-red-500' : 'bg-emerald-500'} `}>
                                            {order?.refund_confirmed === 0 ? "Not Confirmed" : "Confirmed"}
                                        </span>
                                        <span className='text-[0.8vmax] text-gray-400 font-medium block text-center mt-0.5'>{formatDbDate(order?.refund_due_at)}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="flex flex-col gap-[2vmax]">

                        {/* Product Details Card */}
                        <div className='bg-white rounded-xl p-[2vmax] shadow-sm border border-gray-100'>
                            <div className="flex items-center gap-[0.5vmax] mb-[1.5vmax] border-b border-gray-100 pb-[1vmax]">
                                <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                                <h2 className='text-[1.3vmax] font-bold text-gray-800'>Product Details</h2>
                            </div>

                            <div className="border border-gray-100 p-[0.5vmax] rounded-lg cursor-pointer hover:border-indigo-200 transition-colors mb-[1.5vmax]"
                                onClick={() => {
                                    setshowPopup(true)
                                    setImgUrlToShow(order?.custom_image)
                                }}
                            >
                                <img src={order?.custom_image} alt="Product" className="w-full h-auto rounded-lg" />
                            </div>

                            <div className="grid grid-cols-2 gap-[1.2vmax] text-[0.9vmax]">
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Product ID</span>
                                    <span className='font-bold text-gray-700 mt-0.5'>{order?.product_id}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Product Type</span>
                                    <span className='font-bold text-gray-700 mt-0.5'>{order?.product_type_name}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Market</span>
                                    <span className='font-bold text-gray-700 mt-0.5'>{order?.market}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Keyword</span>
                                    <span className='font-bold text-gray-700 mt-0.5 truncate' title={order?.keywords}>
                                        <HoverFullText text={order?.keywords} sliceLength={16} />
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Chinese Seller</span>
                                    <span className='font-bold text-gray-700 mt-0.5 truncate' title={order?.chinese_seller}>
                                        <HoverFullText text={order?.chinese_seller} sliceLength={16} />
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Base Price</span>
                                    <span className='font-bold text-gray-700 mt-0.5'>{order?.product_currency} {order?.base_price}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Seller ID</span>
                                    <span className='font-bold text-gray-700 mt-0.5'>{order?.pmm_id || "N/A"}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Seller Name</span>
                                    <span className='font-bold text-gray-700 mt-0.5 truncate' title={order?.pmm_name}>{order?.pmm_name || "N/A"}</span>
                                </div>
                            </div>
                        </div>

                        {/* Buyer Details Card */}
                        {user?.role !== "PM" &&
                            <div className='bg-white rounded-xl p-[2vmax] shadow-sm border border-gray-100'>
                                <div className="flex items-center gap-[0.5vmax] mb-[1.5vmax] border-b border-gray-100 pb-[1vmax]">
                                    <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                                    <h2 className='text-[1.3vmax] font-bold text-gray-800'>Buyer Details</h2>
                                </div>

                                <div className="grid grid-cols-2 gap-[1.2vmax] text-[0.9vmax]">
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>User / Referral ID</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>{order?.pm_id}</span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Buyer Name</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>{order?.pm_name}</span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Phone Number</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>{order?.pm_country_code} {order?.pm_phone_number}</span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Joined</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>{formatDbDateWithoutTime(order?.pm_created_at)}</span>
                                    </div>
                                </div>

                                <div className="mt-[1.5vmax] pt-[1vmax] border-t border-gray-50">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax] block mb-1'>WhatsApp</span>
                                    <a href={formatWhatsAppNumber(order?.pm_country_code, order?.pm_phone_number)} target="_blank" rel="noopener noreferrer"
                                        className="inline-flex items-center justify-center w-[2.5vmax] h-[2.5vmax] bg-green-500 hover:bg-green-600 text-white rounded-full shadow-sm transition-colors mt-1"
                                        title="Chat on WhatsApp"
                                    >
                                        <i className="fa-brands fa-whatsapp text-[1.2vmax]"></i>
                                    </a>
                                </div>
                            </div>
                        }

                        {/* Seller Details Card (For PM) */}
                        {user?.role === "PM" &&
                            <div className='bg-white rounded-xl p-[2vmax] shadow-sm border border-gray-100'>
                                <div className="flex items-center gap-[0.5vmax] mb-[1.5vmax] border-b border-gray-100 pb-[1vmax]">
                                    <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                                    <h2 className='text-[1.3vmax] font-bold text-gray-800'>Seller Details</h2>
                                </div>

                                <div className="grid grid-cols-2 gap-[1.2vmax] text-[0.9vmax]">
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Seller ID</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>{order?.pmm_id || "N/A"}</span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Seller Name</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>{order?.pmm_name || "N/A"}</span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Phone Number</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>
                                            {order?.pmm_phone_number ? `${order?.pmm_country_code} ${order?.pmm_phone_number}` : "N/A"}
                                        </span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Joined</span>
                                        <span className='font-bold text-gray-700 mt-0.5'>
                                            {order?.pmm_created_at ? formatDbDateWithoutTime(order?.pmm_created_at) : "N/A"}
                                        </span>
                                    </div>
                                </div>

                                <div className="mt-[1.5vmax] pt-[1vmax] border-t border-gray-50">
                                    <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax] block mb-1'>WhatsApp</span>
                                    {order?.pmm_phone_number ? (
                                        <a href={formatWhatsAppNumber(order?.pmm_country_code, order?.pmm_phone_number)} target="_blank" rel="noopener noreferrer"
                                            className="inline-flex items-center justify-center w-[2.5vmax] h-[2.5vmax] bg-green-500 hover:bg-green-600 text-white rounded-full shadow-sm transition-colors mt-1"
                                            title="Chat on WhatsApp"
                                        >
                                            <i className="fa-brands fa-whatsapp text-[1.2vmax]"></i>
                                        </a>
                                    ) : (
                                        <div className="inline-flex items-center justify-center w-[2.5vmax] h-[2.5vmax] bg-gray-300 text-white rounded-full shadow-sm mt-1 cursor-not-allowed" title="WhatsApp not available">
                                            <i className="fa-brands fa-whatsapp text-[1.2vmax]"></i>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </section>

            {/* Popup */}
            {showPopup && imgUrlToShow &&
                <div className="flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-90 z-[999999]">
                    <button className="fixed top-[2vmax] right-[2vmax] text-[2.5vmax] text-white hover:text-gray-300 transition-colors"
                        onClick={() => {
                            setshowPopup(false)
                            setImgUrlToShow("")
                        }}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                    <div className="max-w-[90%] max-h-[90%]">
                        <img src={imgUrlToShow} alt="Enlarged" className="max-w-full max-h-[90vh] rounded-lg shadow-2xl" />
                    </div>
                </div>
            }

            {/* Fixed Action Buttons */}
            <div className="flex justify-end gap-[1vmax] fixed bottom-0 left-0 bg-white p-[1.2vmax_2vmax] shadow-lg border-t border-gray-100 w-full z-50">
                <SingleOrderButtons order={order} user={user} hideViewButton={true} />
            </div>
        </Fragment>
    )
}

export default SingleOrder